import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Filter from "./Filter";
import WorkshopData from "./WorkshopData";
import Map from "./Map";
import { getCoordinates } from "../../../redux/actions/apiActions";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";
import Scrollbars from "react-custom-scrollbars";
import { IoIosClose, IoMdArrowRoundBack } from "react-icons/io";
import { isMobile } from "react-device-detect";
import { setLayer } from "redux/actions/globalAction";
import { setShowMobileIstand } from "redux/actions/cartAction";
import { IoClose } from "react-icons/io5";
import Cart from "../Cart";
import { useRouter } from "next/router";

const WorkshopList = ({
  id,
  setShow,
  getCoordinates,
  apiData,
  getWorkshopFilterMap,
  globalData,
  setCartStage,
  setCartWorkshop,
  removePaddingWhenAutoButtonIsHidden,
  setShowMobileIstand,
  setLayer,
}) => {
  const [map, setMap] = useState(false);
  const [cityFilter, setCityFilter] = useState(0);
  const [scrollingDown, setScrollingDown] = useState(true);
  const router = useRouter();
  useEffect(() => {
    const handleScroll = () => {
      const currentPosition = window.pageYOffset;
      setScrollingDown(currentPosition > 0 && currentPosition > lastScrollTop);
      lastScrollTop = currentPosition;
    };

    let lastScrollTop = 0;

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="workshop-block-island">
        <div className="workshop-block-island-st-1">
          {router?.query?.slug[1] == "tyre" ? (
            <h2>Choose Installation Centre</h2>
          ) : (
            <h2>CHOOSE WORKSHOP</h2>
          )}
          <div className="d-flex justify-content-between align-items-center mns-tp">
            <div
              style={{
                marginRight: "7px",
                fontSize: 12,
                background: "transparent",
              }}
              className="show-section-mobile"
              onClick={() => {
                setLayer(false);
                setShowMobileIstand(false);
              }}
            >
              <span style={{ color: "black", textDecoration: "" }}>
                {" "}
                {isMobile ? (
                  <img src="/assets/BACK.png" width="25px"></img>
                ) : (
                  <>
                    <img
                      src="/assets/BACK.png"
                      width="22px"
                      style={{ marginTop: "-2px" }}
                    ></img>
                  </>
                )}
              </span>
            </div>

            {map && (
              <button
                className="map-view"
                onClick={() => {
                  setMap(!map);
                }}
              >
                {!map ? (
                  <div class="relative-btn">
                    <div className="progress-waves centered-waves">
                      <span />
                    </div>
                  </div>
                ) : null}

                {!map ? (
                  <>
                    <i className="fa-solid fa-location-dot" /> Map View
                  </>
                ) : (
                  <>
                    <i class="fa-solid fa-list"></i> List View
                  </>
                )}
              </button>
            )}
          </div>
        </div>
        {!map ? (
          <>
            <Filter
              cityFilter={cityFilter}
              setCityFilter={setCityFilter}
              getWorkshopFilterMap={getWorkshopFilterMap}
              globalData={globalData}
              apiData={apiData}
              map={map}
              setMap={setMap}
            />
            {apiData.workshopFilterMap == "" ? (
              <div>
                <Skeleton count={3} style={{ height: "170px" }} />
              </div>
            ) : (
              <div
                className={`island-scroller-box-s2 workshop-scroll-v2 ${
                  scrollingDown ? "hide-scroll" : ""
                }`}
              >
                <ul className="workshop-block-island-ul">
                  <WorkshopData
                    id={id}
                    setShow={setShow}
                    cityFilter={cityFilter}
                  />
                </ul>
              </div>
            )}
          </>
        ) : (
          <div>
            {apiData.workshopFilterMap == "" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Skeleton
                  count={5}
                  style={{ width: "55vw", height: "170px" }}
                />
              </div>
            ) : (
              <Map
                id={id}
                getCoordinates={getCoordinates}
                data={apiData}
                getWorkshopFilterMap={getWorkshopFilterMap}
                setShow={setShow}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCoordinates: (lat, lang, size) => {
      dispatch(getCoordinates(lat, lang, size));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkshopList);
